<div class="card">
  <div class="card-body d-flex flex-center flex-column py-9 px-5">
    <div class="symbol symbol-65px symbol-circle mb-5">
      @if (sponsor.logo_url && sponsor.logo_url.length > 0) {
        <img src="{{sponsor.logo_url}}" alt="{{sponsor.sponsor_name}}" style="width: 65px; height: 65px; object-fit: cover; border-radius: 50%;"/>
      } @else {
        <div class="d-flex align-items-center justify-content-center" style="width: 65px; height: 65px; background-color: #f0f0f0; border-radius: 50%;">
          <i class="fa fa-image text-muted" style="font-size: 1.5rem;"></i>
        </div>
      }
    </div>
    <a href="#" class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">{{sponsor.sponsor_name}}</a>
    <div class="fw-semibold text-gray-500 mb-6">{{ sponsor.sponsor_description }}</div>
    <div class="button-container d-flex flex-row">
      <app-button
        [label]="'sponsors.editSponsor' | translate"
        [variant]="'primary'"
        [iconClass]="'fa fa-edit'"
        class="me-2"
        (clicked)="emitEditSponsorClick()"
      />
      <app-button
        [variant]="'outline'"
        [iconClass]="'fa fa-trash'"
        (clicked)="emitDeleteSponsorClick()"
      />
    </div>
  </div>
</div>
